export interface IBusinessUnit {
  ocorrenciaNo: number;
  sigla: any;
  titulo: any;
  habilitado: boolean;
}
